import React from 'react'
import './index.scss'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'

interface RegistrationPopupProps {
    closePopup: () => void
    notEligible: boolean
}

const RegistrationPopup = (props: RegistrationPopupProps) => {
    const { closePopup, notEligible } = props

    return (
        <Popup onClose={closePopup} showClose>
            <div className="registration-modal-container">
                <ConfirmationPopup onConfirm={closePopup} confirmButtonText="Done">
                    {notEligible ? (
                        <>
                            <h3>You are not eligible to become a Member with The MLC</h3>
                            <p>
                                If another party such as a publisher or administrator is responsible for collecting your
                                digital audio mechanical royalties, you are considered fully administered.
                            </p>
                            <p>
                                Your publisher or administrator will handle your royalty collection and registration
                                with The MLC and there is nothing else for you to do at this time. Please contact your
                                publisher or administrator if you have any questions.
                            </p>
                        </>
                    ) : (
                        <>
                            <h3>Not sure if you or another party are responsible for collecting royalties?</h3>
                            <p>
                                Below is a question to ask yourself to decide if you are a self-administered
                                songwriter/the person with the sole right to collect U.S. digital audio mechanical
                                royalties for your works.
                            </p>
                            <p>
                                <strong>Are you working with a publishing rights administrator?</strong>
                                If you currently work with an administrator, and that administrator registers your
                                musical works and collects digital audio mechanicals on your behalf, then you are
                                probably NOT a self-administered songwriter. Your administrator will work with The MLC
                                on your behalf. If you have further questions, we encourage you to contact your rights
                                administrator.
                            </p>
                            <p>
                                Still not sure? <strong>Click the Chat bubble at the bottom of your screen</strong> to
                                connect with a Support Associate for more help.
                            </p>
                        </>
                    )}
                </ConfirmationPopup>
            </div>
        </Popup>
    )
}

export default RegistrationPopup
